import type { SVGProps } from 'react';

interface TeamPlaceholderIconProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
export const TeamPlaceholderIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & TeamPlaceholderIconProps) => (
  <svg
    {...props}
    aria-labelledby={titleId}
    fill="none"
    height="1em"
    role="img"
    viewBox="0 0 20 21"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id={titleId}>{title}</title>
    <g clipPath="url(#team-placeholder_svg__a)" fill="#97ACCC">
      <path d="M3.294 15.363A7.95 7.95 0 0 1 2 11c0-1.009.187-1.972.527-2.861l.795.246c1.216.375 2.102.347 2.424.822.152.223.075 2.052 0 3.823-.063 1.476-.425 1.604-1.668 2.045-.23.081-.49.174-.784.288zM8.095 18.771a8 8 0 0 1-4.353-2.789c.985-.382 2.03-.746 2.245-.798.285-.068.582.067.991.256.195.089.416.19.675.287.65.243.604.814.563 1.317-.01.118-.019.232-.019.337 0 .23-.04.783-.102 1.388zM13.323 18.28A8 8 0 0 1 10 19q-.735-.001-1.433-.127c.118-.924.157-1.889.206-2.2l.003-.02.008-.048c.047-.306.064-.419.128-.46.038-.023.2-.017.286-.014l.111.002c.18 0 .88-.085 1.583-.168.703-.085 1.404-.168 1.583-.168.356 0 .691.671.797 1.658q.05.46.053.825zM17.17 14.554a8.03 8.03 0 0 1-3.433 3.522 3.6 3.6 0 0 0-.061-.624 23 23 0 0 0-.1-.478c-.159-.738-.269-1.249-.016-1.469.304-.265 1.732-.972 2.616-1.305.38-.142.708.038.993.354zM14.95 4.717a7.98 7.98 0 0 1 3.049 6.284c0 .552-.057 1.09-.162 1.609-1.201.852-2.801 1.735-3.399 1.97-.888.348-.87.014-.814-.983l.016-.314c.023-.508.036-1.145.031-2.06.088-1.286.058-1.943.177-2.402.123-.466.28-1.307.6-2.39.222-.749.421-1.423.501-1.714M14.179 4.178q-.056.047-.12.097c-.75.596-3.133 2.254-3.566 2.254s-1.084-.155-1.68-1.546c-.198-.46-.5-1.022-.8-1.577l-.075-.138A8 8 0 0 1 9.998 3c1.532 0 2.962.43 4.178 1.176zM2.803 7.502A8.03 8.03 0 0 1 7.08 3.55c.226.655.535 1.185.811 1.658.275.47.516.884.612 1.31.193.863-1.744 1.902-2.215 2.03-.223.062-.502-.073-.877-.255-.415-.201-.95-.46-1.658-.571a8 8 0 0 1-.949-.223zM12.904 12.58c.111 1.255.21 2.36-.685 2.613-.909.256-2.27.198-3.064 0l-.328-.08c-.888-.213-2.339-.56-2.423-.969-.2-.963-.057-2.097.113-3.23s.227-1.388.495-1.559c.138-.086.582-.55 1.045-1.032.444-.462.904-.942 1.126-1.124.26-.212.95.15 1.66.522l1.46.615c.477.2.606 1.55.582 2.842-.01.508-.017.991.014 1.35l.005.05zM13.53 7.646c.206-.532 1.032-2.725.53-2.576-.5.148-3.535 2.085-2.87 2.306.118.04.866.298.997.347.605.226 1.171.362 1.342-.076z" />
    </g>
    <defs>
      <clipPath id="team-placeholder_svg__a">
        <path d="M0 .5h20v20H0z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
